import { registerModal } from 'features/Modal/ModalRegistry'
import BillingAddBankAccountFormModal from './BillingAddBankAccountFormModal'
import { showModal } from 'features/Modal/Modal.actions'

export const modalType = 'BILLING_ADD_BANK_ACCOUNT'
registerModal(modalType, BillingAddBankAccountFormModal)
export default modalProps =>
  showModal({
    modalType,
    modalProps,
  })



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/BillingAddBankAccountFormModal/BillingAddBankAccountFormModal.action.js